function truncateOrganizationName(organizationDisplayName: string): string {
  return organizationDisplayName.length > 40
    ? `${organizationDisplayName.slice(0, 40)}...`
    : organizationDisplayName;
}

export const TRIP_MESSAGE_REMINDER_DAY_BEFORE = (
  organizationDisplayName: string,
  phoneNumber?: string | null
): string => {
  const orgName = truncateOrganizationName(organizationDisplayName);
  return `Reminder: Your ride with ${orgName} is scheduled for TIME. Call ${
    phoneNumber ?? 'DISPATCH_PHONE_NUMBER'
  } to cancel`;
};

export const TRIP_MESSAGE_REMINDER_NEAR_PICKUP = (
  organizationDisplayName: string
): string => {
  const orgName = truncateOrganizationName(organizationDisplayName);

  return `Your ride with ${orgName} will arrive in MINUTES_UNTIL_PICKUP min. Expect DRIVER_NAME in a VEHICLE_COLOR VEHICLE_MAKE VEHICLE_MODEL`;
};

export const TRIP_MESSAGE_REMINDER_BEFORE_PICKUP_TIME = (
  organizationDisplayName: string
): string => {
  const orgName = truncateOrganizationName(organizationDisplayName);
  return `Your ride with ${orgName} is scheduled for TIME. Expect DRIVER_NAME in a VEHICLE_COLOR VEHICLE_MAKE VEHICLE_MODEL`;
};

export const TRIP_MESSAGE_ACKNOWLEDGEMENT = (
  organizationDisplayName: string,
  phoneNumber?: string | null
): string => {
  const orgName = truncateOrganizationName(organizationDisplayName);
  return `Your trip with ${orgName} is booked for TIME. Call ${
    phoneNumber ?? 'DISPATCH_PHONE_NUMBER'
  } to cancel`;
};

export const PUBLIC_TRIP_PORTAL_MESSAGE = (
  publicTripPortalUrl: string
): string => {
  return publicTripPortalUrl;
};

export const TRIP_MESSAGE_CANCELED = (
  organizationDisplayName: string,
  phoneNumber?: string | null
): string => {
  const orgName = truncateOrganizationName(organizationDisplayName);
  return `Your trip with ${orgName} has been canceled for TIME. Call ${
    phoneNumber ?? 'DISPATCH_PHONE_NUMBER'
  } to reschedule`;
};
